import {DossierScope} from './dossier.model';

export class DossierHistoryModel {
	brand: string;
	customerTradingName: string;
	dossierNumberPrefix: string;
	createdAt: string;
	id: string;
	plate: string;
	km: string;
	scope: DossierScope[];
	status: string;
	archived: boolean;

	constructor(model: any) {
		this.brand = model.brand;
		this.customerTradingName = model.customer_trading_name;
		this.id = model.id;
		this.plate = model.plate;
		this.km = model.km;
		this.scope = [];
		this.dossierNumberPrefix = model.dossier_number_prefix;
		this.archived = model.is_archived;
		this.createdAt = model.created_at;
		model.scope.forEach (scope => {
			this.scope.push(new DossierScope(scope));
		});
		this.status = model.status;
	}

	setArchived(archived: boolean): void {
		this.archived = archived;
	}

	/**
	 * Indica se l'intervento è chiuso-archiviato
	 * Le pratiche associate all'intervento archiviato non possono essere canalizzate
	 * 
	 * @returns {boolean}
	 */
	isArchived(): boolean {
		// return true;
		return !!this.archived;
	}
}
